// Pure scoring math for /helen. No network, no Supabase — everything here is
// a function of rows the page already has, so it can be reasoned about (and
// tested) on its own.
//
// Note that hidden ratings simply never arrive: the RLS policy on `ratings`
// withholds the other person's row until you have rated an entry yourself.
// `entry.rater_ids` is the one thing that always arrives — it says WHO has
// rated, never WHAT they said — so the reveal logic keys off that, not off
// the ratings array.

const num = (value) => (value === null || value === undefined ? null : Number(value));

export function ratingBy(ratings, userId) {
  return (ratings || []).find((r) => r.user_id === userId) || null;
}

export function revealState(entry, viewerId) {
  const raters = entry.rater_ids || [];
  const mine = raters.includes(viewerId);
  const theirs = raters.some((id) => id !== viewerId);

  if (mine && theirs) return 'revealed';
  if (mine) return 'waiting';
  if (theirs) return 'hidden';
  return 'unrated';
}

export function jointAverage(ratings) {
  const scores = (ratings || []).map((r) => num(r.score));
  if (scores.length < 2) return null;
  return scores.reduce((sum, s) => sum + s, 0) / scores.length;
}

export function delta(ratings) {
  const scores = (ratings || []).map((r) => num(r.score));
  if (scores.length < 2) return null;
  return Math.abs(Math.max(...scores) - Math.min(...scores));
}

export function formatScore(score) {
  const n = num(score);
  if (n === null || Number.isNaN(n)) return '—';
  return n.toFixed(1);
}

// Form input -> a score the database will accept, or null if it will not.
export function parseScore(input) {
  if (input === null || input === undefined) return null;
  const text = String(input).trim();
  if (!text) return null;

  const n = Number(text);
  if (Number.isNaN(n) || n < 0 || n > 10) return null;
  return n;
}
